<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.7 13.1"
    aria-hidden="true"
  >
    <path d="M0 0v13h18.4V0H0zm9 8.3L1.1.7h16.2L9 8.3zM6.3 6.6L.7 11.9V1.1l5.6 5.5zm.5.4L9 9.2 11.3 7l5.9 5.3H1.1L6.8 7zm5-.4l5.9-5.5V12l-5.9-5.4z" />
  </svg>
</template>
